export interface IDashboardConfig {
    version: string,
    lastWorkSpaceId: string,
    showFullLeftMenu: boolean,
    workSpaces: {
        id: string,
        title: string,
        config: IModule[],
        stocks: string[]
    }[]
}
export interface IModule {
    id: number,
    module: "MarketOverview" | "CashFlowTrending" | "HeatMapChart" | "StockChart" | "OrderMatchingByPrice" | "StockRanking" | "TopUp" | "TopDown" | "VNIndexPePb" | "TopEPS" | "News" | "Report" | "AnalysisReport" | string
    state: {
        symbols?: string[],
        currentSymbol?: string,
        indexSymbol?: string,
        timeSymbol?: string,
        pageSize?: number,
        top?: number,
        topType?: string,
        monthSymbol?: string,
        currentDataTab?: string,
        pageIndex?: number,
        stockType?: string

    }
}
export enum EMODULE {
    MarketOverview = 'MarketOverview',
    CashFlowTrending = "CashFlowTrending",
    HeatMapChart = "HeatMapChart",
    StockChart = "StockChart",
    OrderMatchingByPrice = "OrderMatchingByPrice",
    StockRanking = "StockRanking",
    TopUp = "TopUp",
    TopDown = "TopDown",
    VNIndexPePb = "VNIndexPePb",
    TopEPS = "TopEPS",
    News = "News",
    Report = "Report",
    TopStock = "TopStock",
    AnalysisReport = "AnalysisReport",
    StockRecommendations = "StockRecommendations",
    MarketStatistic = "MarketStatistic"
}
export enum REGISTER_SOCKET_TYPE {
    RegisMarketInfo = "RegisMarketInfo",
    RegisShortStockInfo = "RegisShortStockInfo"
}
export enum RECEIVE_SOCKET_TYPE {
    RecieveMarketInfo = "RecieveMarketInfo",
    VNINDEXRecieveShortStockInfo = "VNINDEXRecieveShortStockInfo",
    HNXINDEXRecieveShortStockInfo = "HNXINDEXRecieveShortStockInfo",
    UPCOMINDEXRecieveShortStockInfo = "UPCOMINDEXRecieveShortStockInfo"
}
export interface IStockSymbol {
    totalTradingQttyUpdateColor?: string
    basicPrice: number
    ceilingPrice: number
    floorPrice: number
    matchPrice: number
    matchQtty: number
    matchValue: number
    stockSymbol: string
    value: string
    totalTradingQtty: number
    totalTradingValue: number,
    percentChange:{ time: string, changePercent: number }[],
    chgPrice?: number;
    pctPrice?: number;
    marketCap?: number;
    pe?: number;
    pb?: number;
    beta?: number;
    pctPrice1Day?: number
    pctPrice1Month?: number
    pctPrice1Week?: number
    pctPrice1Year?: number
    pctPrice2Weeks?: number
    pctPrice3Months?: number
    pctPrice6Months?: number
    pctPrice9Months?: number
    pctPriceUptoNow?: number
    bvps?: number
    ebit?: number
    eps?: number
    industryName?: string
    interest?: number
    revenue?: number
    yearReport?: number;
    profit?: number;
    previousYear?: number;
    previousRevenue?: number;
    previousProfit?: number;
    changeProfit?: number;
    isUpdate?: boolean,
    colorUpdate?: string,
    highestPrice?: number
    lowestPrice?: number
    priceChange?: number,
    priceChangePercent?: number
}
export interface IMarketIndex {
    stockSymbol: string;
    currentIndex: number;
    chgIndex: number;
    pctIndex: number;
    totalQtty: number;
    totalValue: number;
    advances: number;
    noChange: number;
    declines: number;
    marketStatus: number;
    marketStatusName: string;
    time: string;
    colorUpdate?: string
}
export enum STOCK_COLOR_CONIG {
    UP = "#38CB89",
    CEILING = "#664DC9",
    DOWN = "#EF4B4B",
    UNCHANGE = "#FFAB00",
    FLOOR = "#00A3FF"
}
export enum STOCK_BG_COLOR_CONIG {
    UP = "rgba(56, 203, 137,.2)",
    CEILING = "rgba(102, 77, 201,.2)",
    DOWN = "rgba(239, 75, 75,.2)",
    UNCHANGE = "rgba(255, 171, 0,.2)",
    FLOOR = "rgba(0, 163, 255,0.2)"
}
export interface ListIndex {
    time: any;
    marketIndex: number;
}

export interface ListVolume {
    time: any;
    volume: number;
}

export interface IMarketIndexSummary {
    indexCode: string;
    priorMarketIndex: number;
    listIndex: ListIndex[];
    listVolume: ListVolume[];
    data?: IMarketIndex,
    update?: boolean,
    colorUpdate?: string
}
export interface IShortCompanyInfo {
    companyName: string
    companyNameEn: string
    floorCode: string
    stockSymbol: string
    value: string,
    isHide?: boolean,
    isSelect?: boolean,
    focus: boolean
}
export enum StockType {
    Eps = "Eps",
    TopUp = "TopUp",
    TopDown = "TopDown"
}
export enum TopType {
    Overview = "Overview",
    Change = "Change",
    Finance = "Finance"
}
export enum StockIndexSymbol {
    Overview = "",
    HOSE = "^VNINDEX",
    HNX = "^HNINDEX",
    UPCOM = "^UPCOMINDEX",
    VN30 = "^VN30INDEX"
}
export interface IStockInfo {
    stockSymbol: string;
    matchPrice: number;
    chgPrice: number;
    pctPrice: number;
    totalTradingQtty: number;
    marketCap: number;
    pe: number;
    pb: number;
    beta: number;
}
export interface IEpsStockInfo {
    stockSymbol: string;
    yearReport: number;
    revenue: number;
    profit: number;
    previousYear: number;
    previousRevenue: number;
    previousProfit: number;
    changeProfit: number;
    eps: number;
    pe: number;
}
export enum EMode {
    DARK = "DARK",
    LIGHT = "LIGHT"
}